import { LoadingSpinner } from './LoadingSpinner';
import { cn } from '../../lib/cn';

interface Props {
    /** Texto opcional bajo el spinner (ej. "Cargando…"). */
    label?: string;
    className?: string;
}

/**
 * Spinner de carga para el ÁREA DE CONTENIDO (no fullScreen). El AppShell envuelve el <Outlet/>, así
 * que el sidebar permanece y este spinner ocupa solo el contenido: centrado vertical + horizontal con
 * una min-height razonable para que el "círculo" se vea mientras la query de la pantalla está pending.
 *
 * Reusa el LoadingSpinner (size="lg"), que ya trae role="status" + aria-live (accesible). Patrón de uso
 * en pantallas: `if (isPending) return <ContentLoading />;` antes de renderizar la tabla/contenido.
 */
export function ContentLoading({ label, className }: Props) {
    return (
        <div className={cn('flex h-full min-h-[40vh] items-center justify-center', className)}>
            {/* El círculo toma el color de ACENTO del branding del tenant (--brand-accent, inyectado por
                theme.ts desde accentColor). El icono Loader2 hereda currentColor; el label conserva el suyo
                (text-muted-foreground) porque lo trae explícito. */}
            <LoadingSpinner size="lg" label={label} className="text-brand-accent" />
        </div>
    );
}
